// Copyright (c) 2018 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateModalVisibility = (state, action) =>
    action.isVisible;

export default (state = getDefaultState().isAmountOfUseModalOpen, action) => {

    const actionTypes = {
        [actions.UPDATE_NEW_REGISTRATION_AMOUNT_OF_USE_MODAL_VISIBILITY]: updateModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/product-registration/reducers/amount-of-use-modal-visibility.js